export const insights_german = {
  "Häufige Abkürzungen": "Häufige Abkürzungen",
  "Zentrale Begriffe": "Zentrale Begriffe",
};
